module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gwendolyn Womack\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Originally from Houston, Texas, "), _c('B', [_vm._v("Gwendolyn Womack")]), _vm._v(" studied theater at the University of Alaska, Fairbanks. She holds an MFA in Directing Theatre, Video, and Cinema from California Institute of the Arts. Her first novel, "), _c('I', [_vm._v("The Memory Painter,")]), _vm._v(" was an RWA PRISM award winner in the Time Travel/Steampunk category and a finalist for Best First Novel. She now resides in Los Angeles with her husband and her son.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8C0hmb/tc-custom/9781250053046.jpg?1731883366153",
      "alt": "This image is the cover for the book Memory Painter"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Memory Painter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Two dreamers discover a connection that reaches across history in this award-winning sci-fi romantic thriller: “A mind-explosion of a journey” (Refinery29).")]), _c('br'), _c('br'), _vm._v("World-famous artist Bryan Pierce never reveals the secret to his success. His paintings are all inspired by strangely vivid dreams that he believes to be memories from another life—and he hopes his art will lead him to an answer. And when he meets Linz Jacobs, a neurogenticist who recognizes a recurring childhood nightmare in one Bryan’s paintings, he is convinced she holds the key."), _c('br'), _c('br'), _vm._v("Their meeting triggers Bryan’s most powerful dream yet—visions of a team of scientists who, on the verge of discovering a cure for Alzheimer’s, died in a lab explosion decades ago. As his visions intensify, Bryan and Linz start to discern a pattern. But a deadly enemy watches their every move, and he will stop at nothing to ensure that the past stays buried."), _c('br'), _c('br'), _c('b', [_vm._v("Winner of the RWA Prism Award")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0